"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[1017],{

/***/ 29714:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var Endpoints = exports.Endpoints = {
    update_status_study_guides: {
        namespace: "UpdateStatusStudyGuide",
        actions: {
            update: {
                method: "PUT",
                path: "admin/study_guides/update_status"
            }
        }
    },
    blocked: {
        namespace: "UserBlacklist",
        actions: {
            add: {
                method: "POST",
                path: "blocks"
            },
            delete: {
                method: "DELETE",
                path: "blocks/#{blocked_id}"
            }
        }
    },
    batch_questions: {
        namespace: "BatchQuestion",
        actions: {
            create: {
                method: "POST",
                path: "batch_questions"
            }
        }
    },
    examining_boards: {
        namespace: "ExaminingBoard",
        actions: {
            list: {
                method: "GET",
                path: "examining_boards"
            },
            update: {
                method: "PUT",
                path: "examining_boards/#{slug}"
            }
        }
    },
    disciplines: {
        namespace: "Discipline",
        actions: {
            list: {
                method: "GET",
                path: "disciplines"
            }
        }
    },
    directed_sheet: {
        namespace: "DirectedSheet",
        actions: {
            list: {
                method: "GET",
                path: "directed_sheet/highlight_articles"
            }
        }
    },
    institutes: {
        namespace: "Institute",
        actions: {
            list: {
                method: "GET",
                path: "institutes"
            }
        }
    },
    jobs: {
        namespace: "Job",
        actions: {
            list: {
                method: "GET",
                path: "jobs"
            }
        }
    },
    favorites: {
        namespace: "Favorite",
        actions: {
            create: {
                method: "POST",
                path: "favorites"
            },
            delete: {
                method: "DELETE",
                path: "favorites"
            }
        }
    },
    relationships: {
        namespace: "Relationship",
        actions: {
            create: {
                method: "POST",
                path: "relationships"
            },
            delete: {
                method: "DELETE",
                path: "relationships"
            }
        }
    },
    users: {
        namespace: "User",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "users"
            },
            show: {
                method: "GET",
                path: "users/#{user_id}"
            },
            update: {
                method: "PATCH",
                path: "users/#{user_id}"
            },
            send_email_confirmation: {
                method: "POST",
                path: "users/#{user_id}/send_email_confirmation"
            },
            give_bonus: {
                method: "POST",
                path: "users/#{user_id}/bonus"
            },
            restore: {
                method: "POST",
                path: "users/#{user_id}/restoration"
            },
            used_resources: {
                method: "GET",
                path: "users/#{user_id}/used_resources"
            },
            used_resources_summary: {
                method: "GET",
                path: "users/#{user_id}/used_resources/summary"
            },
            subscription_transactions: {
                method: "GET",
                path: "users/#{user_id}/subscription_transactions"
            },
            histories: {
                method: "GET",
                path: "users/#{user_id}/histories"
            },
            invitations: {
                method: "GET",
                path: "users/#{user_id}/invitations"
            }
        }
    },
    user_info: {
        namespace: "UserInfo",
        actions: {
            show: {
                method: "GET",
                path: "user_infos"
            },
            update: {
                method: "PATCH",
                path: "user_infos"
            }
        }
    },
    user_profile: {
        namespace: "UserProfile",
        actions: {
            show: {
                method: "GET",
                path: "user_profile"
            },
            update: {
                method: "PATCH",
                path: "user_profile"
            }
        }
    },
    user_blacklist: {
        namespace: "UserBlacklist",
        actions: {
            create: {
                method: "POST",
                path: "user_blacklists"
            },
            delete: {
                method: "DELETE",
                path: "user_blacklists/#{id}"
            }
        }
    },
    user_guides: {
        namespace: "UserGuide",
        actions: {
            create: {
                method: "POST",
                path: "user/guides"
            },
            delete: {
                method: "DELETE",
                path: "user/guides/#{id}"
            }
        }
    },
    subscriptions: {
        namespace: "Subscriptions",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "subscriptions"
            },
            unsubscribe: {
                method: "POST",
                path: "subscriptions/unsubscribe"
            }
        }
    },
    exams: {
        namespace: "Exam",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "exams"
            },
            update: {
                method: "PUT",
                path: "exams/#{slug}"
            },
            request: {
                method: "POST",
                path: "exams/#{id}/exam_requests"
            }
        }
    },
    notebooks: {
        namespace: "Notebook",
        actions: {
            list: {
                method: "GET",
                path: "notebooks"
            },
            update: {
                method: "PUT",
                path: "notebooks/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "notebooks/#{id}"
            },
            create: {
                method: "POST",
                path: "notebooks"
            }
        }
    },
    notebooks_questions: {
        namespace: "NotebookQuestion",
        actions: {
            create: {
                method: "POST",
                path: "note_book/questions"
            },
            delete: {
                method: "DELETE",
                path: "note_book/questions/#{id}"
            }
        }
    },
    stored_filters: {
        namespace: "StoredFilter",
        actions: {
            create: {
                method: "POST",
                path: "stored_filters"
            },
            show: {
                method: "GET",
                path: "stored_filters/#{id}"
            },
            update: {
                method: "PUT",
                path: "stored_filters/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "stored_filters/#{id}"
            },
            list: {
                method: "GET",
                path: "stored_filters"
            }
        }
    },
    questions: {
        namespace: "Question",
        custom: true,
        actions: {
            check_limits: {
                method: "POST",
                path: "questions/#{id}/check_limits"
            },
            resolve: {
                method: "POST",
                path: "questions/#{id}/answer"
            },
            list: {
                method: "GET",
                path: "questions"
            },
            request_professor_commentary: {
                method: "POST",
                path: "professor_commentary_requests"
            }
        }
    },
    contests: {
        namespace: "Contest",
        actions: {
            list: {
                method: "GET",
                path: "contests"
            },
            show: {
                method: "GET",
                path: "contests/#{id}"
            }
        }
    },
    annotations: {
        namespace: "Annotation",
        actions: {
            create: {
                method: "POST",
                path: "annotations"
            },
            update: {
                method: "PUT",
                path: "annotations/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "annotations/#{id}"
            }
        }
    },
    lesson_annotations: {
        namespace: "LessonAnnotation",
        actions: {
            create: {
                method: "POST",
                path: "lesson_annotations"
            },
            update: {
                method: "PUT",
                path: "lesson_annotations/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "lesson_annotations/#{id}"
            }
        }
    },
    activities: {
        namespace: "Activity",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "activities"
            },
            create: {
                method: "POST",
                path: "activities"
            },
            create_and_render: {
                method: "POST",
                path: "activities/create_and_render"
            },
            report_abuse: {
                method: "POST",
                path: "activities/#{id}/report_abuse"
            },
            delete: {
                method: "DELETE",
                path: "activities/#{id}"
            }
        }
    },
    activity_comments: {
        namespace: "ActivityComments",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "activities/#{activity_id}/comments"
            },
            create: {
                method: "POST",
                path: "activities/#{activity_id}/comments"
            },
            create_and_render: {
                method: "POST",
                path: "activities/#{activity_id}/comments/create_and_render"
            },
            update: {
                method: "PUT",
                path: "activities/#{activity_id}/comments/#{id}"
            },
            report_abuse: {
                method: "POST",
                path: "activities/#{activity_id}/comments/#{id}/report_abuse"
            },
            delete: {
                method: "DELETE",
                path: "activities/#{activity_id}/comments/#{id}"
            }
        }
    },
    activity_replies: {
        namespace: "ActivityReplies",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies"
            },
            create: {
                method: "POST",
                path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies"
            },
            create_and_render: {
                method: "POST",
                path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/create_and_render"
            },
            update: {
                method: "PUT",
                path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}"
            },
            report_abuse: {
                method: "POST",
                path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}/report_abuse"
            },
            delete: {
                method: "DELETE",
                path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}"
            }
        }
    },
    question_errors: {
        namespace: "QuestionError",
        actions: {
            create: {
                method: "POST",
                path: "question_errors"
            }
        }
    },
    comment_feedbacks: {
        namespace: "CommentFeedback",
        actions: {
            create: {
                method: "POST",
                path: "comment_feedbacks"
            },
            update: {
                method: "PUT",
                path: "comment_feedbacks/#{id}"
            }
        }
    },
    recommended_comment_feedbacks: {
        namespace: "RecommendedCommentFeedback",
        actions: {
            create: {
                method: "POST",
                path: "recommended_comment_feedbacks"
            },
            update: {
                method: "PUT",
                path: "recommended_comment_feedbacks/#{id}"
            }
        }
    },
    monitor_comment_feedbacks: {
        namespace: "MonitorCommentFeedback",
        actions: {
            create: {
                method: "POST",
                path: "monitor_comment_feedbacks"
            },
            update: {
                method: "PUT",
                path: "monitor_comment_feedbacks/#{id}"
            }
        }
    },
    practice_tests_questions: {
        namespace: "PracticeTestsQuestions",
        actions: {
            update: {
                method: "PUT",
                path: "practice_tests/#{practice_test_id}/practice_tests_questions/#{id}"
            }
        }
    },
    practice_tests: {
        namespace: "PracticeTest",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "practice_tests"
            },
            update: {
                method: "PUT",
                path: "practice_tests/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "practice_tests/#{id}"
            },
            create: {
                method: "POST",
                path: "practice_tests"
            },
            correct: {
                method: "POST",
                path: "practice_tests/#{id}/correct"
            },
            create_and_render: {
                method: "POST",
                path: "practice_tests/#{id}/duplicate/create_and_render"
            },
            by_study_guide: {
                method: "POST",
                path: "ils/practice_tests/by_study_guide"
            }
        }
    },
    resolveds: {
        namespace: "Resolved",
        custom: true,
        actions: {
            mass_destroy_all: {
                method: "DELETE",
                path: "resolveds/mass_destroy_all"
            },
            mass_destroy: {
                method: "DELETE",
                path: "resolveds/mass_destroy"
            }
        }
    },
    commentaries: {
        namespace: "Commentary",
        custom: true,
        actions: {
            get_all: {
                method: "GET",
                path: "questions/#{question_id}/commentaries"
            },
            create: {
                method: "POST",
                path: "questions/#{question_id}/commentaries"
            },
            create_and_render: {
                method: "POST",
                path: "questions/#{question_id}/commentaries/create_and_render"
            },
            update: {
                method: "PUT",
                path: "questions/#{question_id}/commentaries/#{id}"
            },
            update_and_render: {
                method: "PUT",
                path: "questions/#{question_id}/commentaries/#{id}/update_and_render"
            },
            like: {
                method: "PUT",
                path: "questions/#{question_id}/commentaries/#{id}/like"
            },
            unlike: {
                method: "PUT",
                path: "questions/#{question_id}/commentaries/#{id}/unlike"
            },
            update_like: {
                method: "PUT",
                path: "questions/#{question_id}/commentaries/#{id}/update_like"
            },
            report_abuse: {
                method: "POST",
                path: "questions/#{question_id}/commentaries/#{id}/report_abuse"
            },
            recommend: {
                method: "POST",
                path: "recommendation/"
            },
            unrecommend: {
                method: "DELETE",
                path: "recommendation/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "questions/#{question_id}/commentaries/#{id}"
            }
        }
    },
    conversations: {
        namespace: "Conversation",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "conversations"
            },
            create: {
                method: "POST",
                path: "conversations"
            },
            delete: {
                method: "DELETE",
                path: "conversations/#{id}"
            },
            read_messages: {
                method: "PUT",
                path: "conversations/#{id}/read_messages"
            }
        }
    },
    league: {
        namespace: "League",
        custom: true,
        actions: {
            join: {
                method: "POST",
                path: "league_agreement"
            },
            quit: {
                method: "DELETE",
                path: "league_agreement"
            }
        }
    },
    messages: {
        namespace: "Message",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "conversations/#{conversation_id}/messages"
            },
            create: {
                method: "POST",
                path: "conversations/#{conversation_id}/messages"
            },
            delete: {
                method: "DELETE",
                path: "conversations/#{conversation_id}/messages/#{id}"
            },
            read: {
                method: "PUT",
                path: "conversations/#{conversation_id}/messages/#{id}/read"
            }
        }
    },
    lesson_feedbacks: {
        namespace: "LessonFeedback",
        actions: {
            create: {
                method: "POST",
                path: "lesson_feedbacks"
            },
            update: {
                method: "PUT",
                path: "lesson_feedbacks/#{id}"
            }
        }
    },
    carts: {
        namespace: "Cart",
        actions: {
            show: {
                method: "GET",
                path: "cart"
            },
            update: {
                method: "PATCH",
                path: "cart"
            },
            delete: {
                method: "DELETE",
                path: "cart"
            }
        }
    },
    orders: {
        namespace: "Order",
        custom: true,
        actions: {
            list: {
                method: "GET",
                path: "orders"
            },
            show: {
                method: "GET",
                path: "orders/#{order_number}"
            },
            create: {
                method: "POST",
                path: "orders"
            },
            update: {
                method: "PATCH",
                path: "orders/#{order_number}"
            },
            delete: {
                method: "DELETE",
                path: "orders/#{order_number}"
            },
            pay: {
                method: "POST",
                path: "orders/#{order_number}/payments"
            },
            refundPayment: {
                method: "POST",
                path: "orders/#{order_number}/payments/#{payment_id}/refund"
            }
        }
    },
    recurrences: {
        namespace: "Recurrence",
        custom: true,
        actions: {
            cancel: {
                method: "POST",
                path: "recurrences/#{id}/cancel"
            },
            pause: {
                method: "PUT",
                path: "recurrences/#{id}/pause"
            },
            resume: {
                method: "PUT",
                path: "recurrences/#{id}/resume"
            },
            apply_discount: {
                method: "PUT",
                path: "recurrences/#{id}/apply_discount"
            }
        }
    },
    cities: {
        namespace: "City",
        actions: {
            list: {
                method: "GET",
                path: "cities"
            }
        }
    },
    share: {
        namespace: "Share",
        actions: {
            create: {
                method: "POST",
                path: "share"
            }
        }
    },
    lessons: {
        namespace: "Lesson",
        actions: {
            show: {
                method: "GET",
                path: "lessons/#{id}"
            },
            list: {
                method: "GET",
                path: "lessons"
            }
        }
    },
    user_lesson_progress: {
        namespace: "UserLessonProgress",
        actions: {
            update: {
                method: "PATCH",
                path: "lessons/#{lesson_id}/progress"
            }
        }
    },
    user_preferences: {
        namespace: "UserPreference",
        actions: {
            show: {
                method: "GET",
                path: "user_preferences"
            },
            update: {
                method: "PATCH",
                path: "user_preferences"
            }
        }
    },
    user_onboards: {
        namespace: "UserOnboards",
        actions: {
            show: {
                method: "GET",
                path: "user_onboards"
            },
            create: {
                method: "POST",
                path: "user_onboards"
            }
        }
    },
    progresses: {
        namespace: "Progresses",
        actions: {
            create: {
                method: "POST",
                path: "ils/progresses"
            },
            delete: {
                method: "DELETE",
                path: "ils/progresses"
            }
        }
    },
    ratings: {
        namespace: "Ratings",
        actions: {
            create: {
                method: "POST",
                path: "ils/ratings"
            },
            show: {
                method: "GET",
                path: "ils/ratings"
            },
            update: {
                method: "PATCH",
                path: "ils/ratings"
            }
        }
    },
    content_infos: {
        namespace: "ContentInfos",
        actions: {
            show: {
                method: "GET",
                path: "ils/my_guide/content_infos"
            }
        }
    },
    deprecated_orders: {
        namespace: "DeprecatedOrders",
        actions: {
            list: {
                method: "GET",
                path: "deprecated_orders"
            }
        }
    },
    question_maintenances: {
        namespace: "QuestionMaintenances",
        actions: {
            create: {
                method: "POST",
                path: "ils/question_maintenances"
            }
        }
    },
    excerpts: {
        namespace: "Excerpts",
        actions: {
            list: {
                method: "GET",
                path: "ils/excerpts"
            }
        }
    },
    mind_maps: {
        namespace: "MindMaps",
        actions: {
            list: {
                method: "GET",
                path: "ils/mind_maps"
            },
            show: {
                method: "GET",
                path: "ils/mind_maps/#{id}"
            },
            create: {
                method: "POST",
                path: "ils/mind_maps"
            },
            delete: {
                method: "DELETE",
                path: "ils/mind_maps/#{id}"
            }
        }
    },
    mind_maps_like: {
        namespace: "MindMapsLike",
        actions: {
            update: {
                method: "PATCH",
                path: "ils/mind_maps/#{id}/like"
            },
            delete: {
                method: "DELETE",
                path: "ils/mind_maps/#{id}/like"
            }
        }
    },
    markings: {
        namespace: "Marking",
        actions: {
            list: {
                method: "GET",
                path: "ils/markings"
            },
            show: {
                method: "GET",
                path: "ils/markings/#{id}"
            },
            create: {
                method: "POST",
                path: "ils/markings"
            },
            update: {
                method: "PATCH",
                path: "ils/markings/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "ils/markings/#{id}"
            }
        }
    },
    chapters: {
        namespace: "Chapter",
        custom: true,
        actions: {
            complete: {
                method: "POST",
                path: "ils/chapters/#{id}/complete"
            },
            uncomplete: {
                method: "DELETE",
                path: "ils/chapters/#{id}/complete"
            }
        }
    },
    chapter_resolveds: {
        namespace: "ChapterResolveds",
        actions: {
            create: {
                method: "POST",
                path: "ils/chapter_resolveds"
            }
        }
    },
    inquiries: {
        namespace: "Inquiry",
        actions: {
            list: {
                method: "GET",
                path: "ils/inquiries"
            },
            create: {
                method: "POST",
                path: "ils/inquiries"
            },
            update: {
                method: "PATCH",
                path: "ils/inquiries/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "ils/inquiries/#{id}"
            }
        }
    },
    tasks: {
        namespace: "Tasks",
        actions: {
            create: {
                method: "POST",
                path: "ils/tasks"
            },
            update: {
                method: "PATCH",
                path: "ils/tasks/#{id}"
            },
            list: {
                method: "GET",
                path: "ils/tasks"
            }
        }
    },
    onboarding: {
        namespace: "Onboarding",
        actions: {
            create: {
                method: "POST",
                path: "ils/onboarding"
            }
        }
    },
    user_favorite_tracks: {
        namespace: "UserFavoriteTracks",
        actions: {
            create: {
                method: "POST",
                path: "ils/user_favorite_tracks"
            },
            delete: {
                method: "DELETE",
                path: "ils/user_favorite_tracks"
            }
        }
    },
    topic_downloads: {
        namespace: "TopicDownloads",
        actions: {
            create: {
                method: "POST",
                path: "ils/topics/#{topic_id}/download"
            }
        }
    },
    topic_pdf: {
        namespace: "TopicPdf",
        actions: {
            create: {
                method: "POST",
                path: "ils/topics/#{topic_id}/print"
            }
        }
    },
    topic_videos_visit: {
        namespace: "TopicVideosVisit",
        actions: {
            create: {
                method: "POST",
                path: "ils/topic_videos/#{topic_video_id}/visit"
            },
            delete: {
                method: "DELETE",
                path: "ils/topic_videos/#{topic_video_id}/visit"
            }
        }
    },
    filters: {
        namespace: "Filter",
        actions: {
            show: {
                method: "GET",
                path: "filters/#{product}"
            }
        }
    },
    forum_replies: {
        namespace: "ForumReplies",
        actions: {
            create: {
                method: "POST",
                path: "ils/forum/replies"
            },
            delete: {
                method: "DELETE",
                path: "ils/forum/replies/#{id}"
            }
        }
    },
    forum_votes: {
        namespace: "ForumVotes",
        actions: {
            update: {
                method: "PUT",
                path: "ils/forum/#{type}/#{id}/vote"
            },
            delete: {
                method: "DELETE",
                path: "ils/forum/#{type}/#{id}/vote"
            }
        }
    },
    forum_posts: {
        namespace: "ForumPosts",
        actions: {
            create: {
                method: "POST",
                path: "ils/forum/posts"
            },
            update: {
                method: "PUT",
                path: "ils/forum/posts/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "ils/forum/posts/#{id}"
            }
        }
    },
    visits: {
        namespace: "Visits",
        actions: {
            create: {
                method: "POST",
                path: "visits"
            }
        }
    },
    performance: {
        namespace: "Performance",
        custom: true,
        actions: {
            general: {
                method: "GET",
                path: "performance"
            },
            chapter: {
                method: "GET",
                path: "ils/chapter_performance"
            }
        }
    },
    highlights: {
        namespace: "Highlight",
        actions: {
            list: {
                method: "GET",
                path: "highlights"
            },
            update: {
                method: "PUT",
                path: "highlights/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "highlights/#{id}"
            },
            create: {
                method: "POST",
                path: "highlights"
            }
        }
    },
    folders: {
        namespace: "NotebooksFolders",
        actions: {
            list: {
                method: "GET",
                path: "folders"
            },
            show: {
                method: "GET",
                path: "folders/#{id}"
            },
            create: {
                method: "POST",
                path: "folders"
            },
            delete: {
                method: "DELETE",
                path: "folders/#{id}"
            }
        }
    },
    ranking_entry: {
        namespace: "RankingEntry",
        actions: {
            create: {
                method: "POST",
                path: "rankings/#{id}/entries"
            }
        }
    },
    performance_targets: {
        namespace: "PerformanceTarget",
        actions: {
            show: {
                method: "GET",
                path: "performance_targets"
            },
            create: {
                method: "POST",
                path: "performance_targets"
            }
        }
    },
    ils_practice_tests: {
        namespace: "IlsPracticeTest",
        actions: {
            create: {
                method: "POST",
                path: "ils/practice_tests/#{type}"
            },
            delete: {
                method: "DELETE",
                path: "ils/practice_tests/#{id}"
            }
        }
    },
    ils_practice_tests_attempts: {
        namespace: "IlsPracticeTestsAttempt",
        actions: {
            create: {
                method: "POST",
                path: "ils/practice_tests/attempts"
            },
            complete: {
                method: "POST",
                path: "ils/practice_tests/attempts/#{id}/complete"
            }
        }
    },
    ils_practice_tests_attempt_questions: {
        namespace: "IlsPracticeTestsAttemptQuestions",
        actions: {
            update: {
                method: "PUT",
                path: "ils/practice_tests/attempts/#{attemptId}/questions/#{id}"
            }
        }
    },
    user_xrays: {
        namespace: "UserXrays",
        actions: {
            create: {
                method: "POST",
                path: "xrays/user_xrays"
            },
            delete: {
                method: "DELETE",
                path: "xrays/user_xrays/#{id}"
            }
        }
    },
    study_blocks: {
        namespace: "StudyBlocks",
        actions: {
            list: {
                method: "GET",
                path: "ils/study_plans/blocks"
            },
            create: {
                method: "POST",
                path: "ils/study_plans/blocks"
            },
            check: {
                method: "PUT",
                path: "ils/study_plans/block_occurrences/#{id}/complete"
            },
            uncheck: {
                method: "DELETE",
                path: "ils/study_plans/block_occurrences/#{id}/reset"
            }
        }
    },
    block_occurrences: {
        namespace: "BlockOccurrences",
        actions: {
            update: {
                method: "PUT",
                path: "ils/study_plans/block_occurrences/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "ils/study_plans/block_occurrences/#{id}"
            }
        }
    },
    study_types: {
        namespace: "StudyType",
        actions: {
            check: {
                method: "POST",
                path: "ils/study_plans/block_occurrence_study_types"
            },
            uncheck: {
                method: "DELETE",
                path: "ils/study_plans/block_occurrence_study_types"
            }
        }
    },
    study_guides: {
        namespace: "StudyGuides",
        actions: {
            favorite: {
                method: "PATCH",
                path: "guia-de-estudos/favorito"
            },
            delete: {
                method: "DELETE",
                path: "user/study_guides/#{study_guide_id}"
            }
        }
    },
    study_plans: {
        namespace: "StudyPlans",
        actions: {
            silence: {
                method: "POST",
                path: "ils/study_plans/study_plans/silence"
            },
            delete: {
                method: "DELETE",
                path: "ils/study_plans/study_plans"
            }
        }
    },
    oriented_study_contract: {
        namespace: "OrientedStudyContract",
        actions: {
            create: {
                method: "POST",
                path: "ils/oriented_study/contract"
            },
            update: {
                method: "PUT",
                path: "ils/oriented_study/contract/#{id}"
            }
        }
    },
    oriented_study_progress: {
        namespace: "OrientedStudyProgress",
        actions: {
            create: {
                method: "POST",
                path: "ils/oriented_study/contract/#{contractId}/progress"
            },
            delete: {
                method: "DELETE",
                path: "ils/oriented_study/contract/#{contractId}/progress"
            }
        }
    },
    oriented_study_progress_bulk: {
        namespace: "OrientedStudyProgressBulk",
        actions: {
            create: {
                method: "POST",
                path: "ils/oriented_study/contract/#{contractId}/progress/bulk"
            },
            delete: {
                method: "DELETE",
                path: "ils/oriented_study/contract/#{contractId}/progress/bulk"
            }
        }
    },
    coach_practice_tests: {
        namespace: "CoachPracticeTest",
        actions: {
            create: {
                method: "POST",
                path: "ils/coach/practice_tests"
            }
        }
    },
    coach_notebooks: {
        namespace: "CoachNotebook",
        actions: {
            create: {
                method: "POST",
                path: "ils/coach/notebooks"
            }
        }
    },
    coach_rate: {
        namespace: "CoachRate",
        custom: true,
        actions: {
            rate: {
                method: "GET",
                path: "ils/coach/rates"
            }
        }
    },
    coach_freemium: {
        namespace: 'CoachFreemium',
        actions: {
            show: {
                method: "GET",
                path: "ils/coach/freemium_cycles/#{userId}"
            }
        }
    },
    user_trials: {
        namespace: "UserTrial",
        actions: {
            create: {
                method: "POST",
                path: "user_trial"
            }
        }
    },
    olympics_agreement: {
        namespace: "OlympicsAgreement",
        actions: {
            create: {
                method: "POST",
                path: "olympic_agreements"
            }
        }
    },
    bnpl: {
        namespace: "Bnpl",
        custom: true,
        actions: {
            authorize: {
                method: "POST",
                path: "checkout/bnpl/authorization"
            }
        }
    },
    cards: {
        namespace: "Cards",
        custom: true,
        actions: {
            create: {
                method: "POST",
                path: "/cards/"
            },
            list: {
                method: "GET",
                path: "/cards"
            },
            init: {
                method: "GET",
                path: "/cards/init"
            },
            show: {
                method: "GET",
                path: "/cards/#{id}"
            },
            delete: {
                method: "DELETE",
                path: "/cards/#{id}"
            },
            default: {
                method: "PUT",
                path: "/cards/default"
            }
        }
    },
    trial_plans: {
        namespace: "TrialPlans",
        actions: {
            create: {
                method: "POST",
                path: "checkout/payments"
            }
        }
    },
    ownable_acquisitions: {
        namespace: "OwnableAcquisitions",
        actions: {
            list: {
                method: "GET",
                path: "ownable_acquisitions"
            }
        }
    },
    bifrost_institutes: {
        namespace: "BifrostInstitutes",
        actions: {
            list: {
                method: "GET",
                path: "bifrost/institutes"
            }
        }
    },
    bifrost_jobs: {
        namespace: "BifrostJobs",
        actions: {
            list: {
                method: "GET",
                path: "bifrost/jobs"
            }
        }
    },
    bifrost_suggested_institutes: {
        namespace: "BifrostSuggestedInstitutes",
        actions: {
            create: {
                method: "POST",
                path: "bifrost/suggested_institutes"
            }
        }
    },
    user_setup_suggestions_institutes: {
        namespace: "UserSetupSuggestionsInstitutes",
        actions: {
            list: {
                method: "GET",
                path: "user_setup/suggestions"
            }
        }
    }
};


/***/ }),

/***/ 61017:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var _endpoints = __webpack_require__(29714);
var _parser = __webpack_require__(7151);
var _model = __webpack_require__(17581);
var _custom = __webpack_require__(84992);
var Custom = _interopRequireWildcard(_custom);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
var Thor = {
    _routes: {},
    setup: function setup(_ref) {
        var _ref$token = _ref.token, token = _ref$token === undefined ? null : _ref$token, _ref$usejQ = _ref.usejQ, usejQ = _ref$usejQ === undefined ? false : _ref$usejQ, _ref$host = _ref.host, host = _ref$host === undefined ? location.origin : _ref$host, _ref$hooks = _ref.hooks, hooks = _ref$hooks === undefined ? {} : _ref$hooks;
        this._routes = _parser.Parser.prepareCalls(_endpoints.Endpoints, {
            usejQ: usejQ,
            token: token,
            host: host,
            hooks: _extends({
                beforeSend: function beforeSend(_ref2) {
                    var qs = _ref2.qs, headers = _ref2.headers, data = _ref2.data;
                    return {
                        qs: qs,
                        headers: headers,
                        data: data
                    };
                }
            }, hooks)
        });
        for(var endpoint in _endpoints.Endpoints){
            var namespace = _endpoints.Endpoints[endpoint].namespace;
            this[namespace] = new _model.Model(this, endpoint, namespace, Custom[endpoint]);
        }
    }
};
exports.Z = Thor;


/***/ }),

/***/ 80874:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var activities = {
    create_and_render: function create_and_render() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().create_and_render(conditions, options);
    },
    report_abuse: function report_abuse() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().report_abuse(conditions, options);
    }
};
exports.activities = activities;


/***/ }),

/***/ 73579:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var activity_comments = {
    create_and_render: function create_and_render() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().create_and_render(conditions, options);
    },
    report_abuse: function report_abuse() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().report_abuse(conditions, options);
    }
};
exports.activity_comments = activity_comments;


/***/ }),

/***/ 52612:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var activity_replies = {
    create_and_render: function create_and_render() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().create_and_render(conditions, options);
    },
    report_abuse: function report_abuse() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().report_abuse(conditions, options);
    }
};
exports.activity_replies = activity_replies;


/***/ }),

/***/ 54276:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var bnpl = {
    authorize: function authorize() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().authorize(conditions, options);
    }
};
exports.bnpl = bnpl;


/***/ }),

/***/ 54882:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var cards = {
    default: function _default() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().default(conditions, options, function(xhr, response) {
            return response;
        });
    },
    init: function init() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().init(conditions, options, function(xhr, response) {
            return response;
        });
    }
};
exports.cards = cards;


/***/ }),

/***/ 7807:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var chapters = {
    complete: function complete() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().complete(conditions, options);
    },
    uncomplete: function uncomplete() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().uncomplete(conditions, options);
    }
};
exports.chapters = chapters;


/***/ }),

/***/ 73701:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var coach_rate = {
    rate: function rate() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().rate(conditions, options, function(xhr, response) {
            return response;
        });
    }
};
exports.coach_rate = coach_rate;


/***/ }),

/***/ 35200:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var commentaries = {
    like: function like() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().like(conditions, options);
    },
    unlike: function unlike() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().unlike(conditions, options);
    },
    update_like: function update_like() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().update_like(conditions, options);
    },
    report_abuse: function report_abuse() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().report_abuse(conditions, options);
    },
    create_and_render: function create_and_render() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().create_and_render(conditions, options);
    },
    update_and_render: function update_and_render() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().update_and_render(conditions, options);
    },
    get_all: function get_all() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().get_all(conditions, options);
    },
    recommend: function recommend() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().recommend(conditions, options);
    },
    unrecommend: function unrecommend() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().unrecommend(conditions, options);
    }
};
exports.commentaries = commentaries;


/***/ }),

/***/ 15914:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var conversations = {
    read_messages: function read_messages() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().read_messages(conditions, options);
    }
};
exports.conversations = conversations;


/***/ }),

/***/ 45312:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var exams = {
    request: function request() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().request(conditions, options);
    }
};
exports.exams = exams;


/***/ }),

/***/ 7801:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var ils_practice_tests_attempts = {
    complete: function complete() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().complete(conditions, options);
    }
};
exports.ils_practice_tests_attempts = ils_practice_tests_attempts;


/***/ }),

/***/ 84992:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _activities = __webpack_require__(80874);
Object.keys(_activities).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _activities[key];
        }
    });
});
var _activity_comments = __webpack_require__(73579);
Object.keys(_activity_comments).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _activity_comments[key];
        }
    });
});
var _activity_replies = __webpack_require__(52612);
Object.keys(_activity_replies).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _activity_replies[key];
        }
    });
});
var _questions = __webpack_require__(24750);
Object.keys(_questions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _questions[key];
        }
    });
});
var _exams = __webpack_require__(45312);
Object.keys(_exams).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _exams[key];
        }
    });
});
var _practice_tests = __webpack_require__(4034);
Object.keys(_practice_tests).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _practice_tests[key];
        }
    });
});
var _resolveds = __webpack_require__(16844);
Object.keys(_resolveds).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _resolveds[key];
        }
    });
});
var _users = __webpack_require__(76546);
Object.keys(_users).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _users[key];
        }
    });
});
var _commentaries = __webpack_require__(35200);
Object.keys(_commentaries).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _commentaries[key];
        }
    });
});
var _conversations = __webpack_require__(15914);
Object.keys(_conversations).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _conversations[key];
        }
    });
});
var _messages = __webpack_require__(64315);
Object.keys(_messages).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _messages[key];
        }
    });
});
var _orders = __webpack_require__(7629);
Object.keys(_orders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _orders[key];
        }
    });
});
var _recurrences = __webpack_require__(39011);
Object.keys(_recurrences).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _recurrences[key];
        }
    });
});
var _league = __webpack_require__(67124);
Object.keys(_league).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _league[key];
        }
    });
});
var _chapters = __webpack_require__(7807);
Object.keys(_chapters).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _chapters[key];
        }
    });
});
var _performance = __webpack_require__(63116);
Object.keys(_performance).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _performance[key];
        }
    });
});
var _ils_practice_tests_attempts = __webpack_require__(7801);
Object.keys(_ils_practice_tests_attempts).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _ils_practice_tests_attempts[key];
        }
    });
});
var _study_plans = __webpack_require__(83240);
Object.keys(_study_plans).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _study_plans[key];
        }
    });
});
var _study_blocks = __webpack_require__(87489);
Object.keys(_study_blocks).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _study_blocks[key];
        }
    });
});
var _study_types = __webpack_require__(61440);
Object.keys(_study_types).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _study_types[key];
        }
    });
});
var _bnpl = __webpack_require__(54276);
Object.keys(_bnpl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _bnpl[key];
        }
    });
});
var _cards = __webpack_require__(54882);
Object.keys(_cards).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _cards[key];
        }
    });
});
var _study_guides = __webpack_require__(19954);
Object.keys(_study_guides).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _study_guides[key];
        }
    });
});
var _coach_rate = __webpack_require__(73701);
Object.keys(_coach_rate).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _coach_rate[key];
        }
    });
});
var _subscriptions = __webpack_require__(82118);
Object.keys(_subscriptions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _subscriptions[key];
        }
    });
});


/***/ }),

/***/ 67124:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var league = {
    join: function join() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().join(conditions, options);
    },
    quit: function quit() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().quit(conditions, options);
    }
};
exports.league = league;


/***/ }),

/***/ 64315:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var messages = {
    read: function read() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().read(conditions, options);
    }
};
exports.messages = messages;


/***/ }),

/***/ 7629:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var orders = {
    pay: function pay() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().pay(conditions, options);
    },
    refundPayment: function refundPayment() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().refundPayment(conditions, options);
    }
};
exports.orders = orders;


/***/ }),

/***/ 63116:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var performance = {
    general: function general() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().general(conditions, options);
    },
    chapter: function chapter() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().chapter(conditions, options);
    }
};
exports.performance = performance;


/***/ }),

/***/ 4034:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var practice_tests = {
    correct: function correct() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().correct(conditions, options);
    },
    create_and_render: function create_and_render() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().create_and_render(conditions, options);
    },
    by_study_guide: function by_study_guide() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().by_study_guide(conditions, options);
    }
};
exports.practice_tests = practice_tests;


/***/ }),

/***/ 24750:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var questions = {
    resolve: function resolve() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().resolve(conditions, options);
    },
    check_limits: function check_limits() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().check_limits(conditions, options);
    },
    request_professor_commentary: function request_professor_commentary() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().request_professor_commentary(conditions, options);
    }
};
exports.questions = questions;


/***/ }),

/***/ 39011:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var recurrences = {
    cancel: function cancel() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().cancel(conditions, options, function(xhr, response) {
            return response;
        });
    },
    pause: function pause() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().pause(conditions, options, function(xhr, response) {
            return response;
        });
    },
    resume: function resume() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().resume(conditions, options, function(xhr, response) {
            return response;
        });
    },
    apply_discount: function apply_discount() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().apply_discount(conditions, options, function(xhr, response) {
            return response;
        });
    }
};
exports.recurrences = recurrences;


/***/ }),

/***/ 16844:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var resolveds = {
    mass_destroy_all: function mass_destroy_all() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().mass_destroy_all(conditions, options);
    },
    mass_destroy: function mass_destroy() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().mass_destroy(conditions, options);
    }
};
exports.resolveds = resolveds;


/***/ }),

/***/ 87489:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var study_blocks = {
    check: function check() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().check(conditions, options);
    },
    uncheck: function uncheck() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().uncheck(conditions, options);
    }
};
exports.study_blocks = study_blocks;


/***/ }),

/***/ 19954:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var study_guides = {
    favorite: function favorite() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().favorite(conditions, options);
    }
};
exports.study_guides = study_guides;


/***/ }),

/***/ 83240:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var study_plans = {
    silence: function silence() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().silence(conditions, options);
    }
};
exports.study_plans = study_plans;


/***/ }),

/***/ 61440:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var study_types = {
    check: function check() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().check(conditions, options);
    },
    uncheck: function uncheck() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().uncheck(conditions, options);
    }
};
exports.study_types = study_types;


/***/ }),

/***/ 82118:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var subscriptions = {
    unsubscribe: function unsubscribe() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().unsubscribe(conditions, options);
    }
};
exports.subscriptions = subscriptions;


/***/ }),

/***/ 76546:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var users = {
    send_email_confirmation: function send_email_confirmation() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().send_email_confirmation(conditions, options);
    },
    give_bonus: function give_bonus() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().give_bonus(conditions, options);
    },
    restore: function restore() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().restore(conditions, options);
    },
    used_resources: function used_resources() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().used_resources(conditions, options);
    },
    used_resources_summary: function used_resources_summary() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().used_resources_summary(conditions, options);
    },
    subscription_transactions: function subscription_transactions() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().subscription_transactions(conditions, options);
    },
    histories: function histories() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().histories(conditions, options);
    },
    invitations: function invitations() {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.action().invitations(conditions, options);
    }
};
exports.users = users;


/***/ }),

/***/ 17581:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Model = exports.Model = function() {
    function Model(Thor, operator, endpoint) {
        var Custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        _classCallCheck(this, Model);
        this.Thor = Thor;
        this.operator = operator;
        this.namespace = endpoint.namespace;
        this.prefixKey = endpoint.prefixKey;
        this.total_pages = null;
        this.total_count = null;
        this.current_page = null;
        this.collection = [];
        for(var method in Custom){
            this[method] = Custom[method];
        }
    }
    _createClass(Model, [
        {
            key: "action",
            value: function action() {
                return this.Thor._routes[this.operator];
            }
        },
        {
            key: "get",
            value: function get() {
                var _this = this;
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.action().list(conditions, options, function(xhr, response) {
                    _this.collection = response[_this.operator];
                    _this.total_pages = response.meta.total_pages;
                    _this.current_page = response.meta.current_page;
                    _this.total_count = response.meta.total_count;
                    return _this.collection;
                });
            }
        },
        {
            key: "create",
            value: function create() {
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.action().create(conditions, options);
            }
        },
        {
            key: "show",
            value: function show() {
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.action().show(conditions, options);
            }
        },
        {
            key: "update",
            value: function update() {
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.action().update(conditions, options);
            }
        },
        {
            key: "delete",
            value: function _delete() {
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.action().delete(conditions, options);
            }
        },
        {
            key: "list",
            value: function list() {
                return this.collection;
            }
        }
    ]);
    return Model;
}();


/***/ }),

/***/ 7151:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.Parser = undefined;
var _request = __webpack_require__(98308);
var Parser = exports.Parser = {
    prepareCalls: function prepareCalls(Endpoints, settings) {
        var calls = {};
        for(var key in Endpoints){
            calls[key] = this.run(key, Endpoints[key], settings);
        }
        return calls;
    },
    run: function run(endpoint, endpointSettings, settings) {
        var endpointMethods = {};
        for(var action in endpointSettings.actions){
            endpointMethods[action] = _request.Requester.bindMethod(endpointSettings.actions[action], settings);
        }
        return endpointMethods;
    }
};


/***/ }),

/***/ 57741:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var Replacer = exports.Replacer = {
    replaceConditions: function replaceConditions(endpointPath, conditions) {
        for(var key in conditions){
            endpointPath = endpointPath.replace("#{" + key + "}", conditions[key]);
        }
        return endpointPath;
    }
};


/***/ }),

/***/ 98308:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.Requester = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var _replacer = __webpack_require__(57741);
function encodeValue(value) {
    var valid = value == null || typeof value === "function";
    return valid ? "" : encodeURIComponent(normalizeValue(value));
}
function normalizeValue(value) {
    var stringValue = value.toString();
    var canNormalize = typeof stringValue.normalize === 'function';
    return canNormalize ? stringValue.normalize("NFKC") : stringValue;
}
function buildQueryString(qs) {
    return Object.keys(qs).reduce(function(acc, key) {
        var encodedKey = encodeValue(key);
        var str = '';
        if (Array.isArray(qs[key])) {
            str = qs[key].reduce(function(acc, val) {
                var encodedVal = encodeValue(val);
                if (encodedVal != null && encodedVal !== '') {
                    acc += "&" + encodedKey + "=" + encodedVal;
                }
                return acc;
            }, '');
        } else {
            var encodedVal = encodeValue(qs[key]);
            if (encodedVal != null && encodedVal !== '') {
                str = "&" + encodedKey + "=" + encodedVal;
            }
        }
        return acc + str;
    }, '').replace(/^&/, '');
}
var Requester = exports.Requester = {
    _meta: function _meta(xhr) {
        return {
            status: xhr.status,
            error: xhr.statusText
        };
    },
    authToken: function authToken(token) {
        return token ? {
            Authorization: "Token token=\"" + token + "\""
        } : {};
    },
    $callFn: function $callFn(_ref, conditions) {
        var token = _ref.token, host = _ref.host, hooks = _ref.hooks;
        var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _this = this;
        var successCallback = arguments[3];
        var failCallback = arguments[4];
        var actionParams = settings.actionParams, _settings$callOptions = settings.callOptions, callOptions = _settings$callOptions === undefined ? {} : _settings$callOptions;
        var path = _replacer.Replacer.replaceConditions(actionParams.path, conditions);
        var url = host + "/api/" + path;
        var _hooks$beforeSend = hooks.beforeSend({
            qs: callOptions.qs || {},
            headers: _extends({}, this.authToken(token)),
            data: callOptions.data || {}
        }), qs = _hooks$beforeSend.qs, headers = _hooks$beforeSend.headers, data = _hooks$beforeSend.data;
        delete callOptions.qs;
        var ajaxOptions = _extends({
            method: actionParams.method,
            contentType: 'application/json',
            headers: headers,
            url: url + "?" + window.jQuery.param(qs)
        }, callOptions, {
            data: normalizeValue(JSON.stringify(data))
        });
        var defer = window.jQuery.Deferred();
        window.jQuery.ajax(ajaxOptions).done(function(data, textStatus, xhr) {
            if (xhr.status >= 200 && xhr.status <= 299) {
                defer.resolve(successCallback(_this._meta(xhr), data));
            } else {
                defer.reject(failCallback(new Error("Server " + ajaxOptions.url + " responded with " + xhr.status + ": " + xhr.statusText), xhr));
            }
        }).fail(function(xhr) {
            defer.reject(failCallback(new Error("Server " + ajaxOptions.url + " responded with " + xhr.status + ": " + xhr.statusText), xhr));
        });
        return defer;
    },
    callFn: function callFn(_ref2, conditions) {
        var token = _ref2.token, host = _ref2.host, hooks = _ref2.hooks;
        var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _this2 = this;
        var successCallback = arguments[3];
        var failCallback = arguments[4];
        var actionParams = settings.actionParams, _settings$callOptions2 = settings.callOptions, callOptions = _settings$callOptions2 === undefined ? {} : _settings$callOptions2;
        var path = _replacer.Replacer.replaceConditions(actionParams.path, conditions);
        var url = host + "/api/" + path;
        var baseHeaders = _extends({
            'Content-Type': 'application/json'
        }, this.authToken(token));
        var _hooks$beforeSend2 = hooks.beforeSend({
            qs: callOptions.qs || {},
            headers: baseHeaders,
            data: callOptions.data || {}
        }), qs = _hooks$beforeSend2.qs, headers = _hooks$beforeSend2.headers, data = _hooks$beforeSend2.data;
        var opts = {
            method: actionParams.method,
            headers: new Headers(headers),
            credentials: 'include'
        };
        url += "?" + buildQueryString(qs);
        var body = JSON.stringify(data);
        if (body !== "{}") {
            if (opts.method === 'GET') {
                url += "&" + buildQueryString(data);
            } else {
                opts.body = body;
            }
        }
        return new Promise(function(resolve, reject) {
            fetch(url, opts).then(function(res) {
                if (res.ok) {
                    return res.text().then(function(text) {
                        if (!text || text && !text.trim()) {
                            resolve(successCallback(_this2._meta(res), {}));
                        } else {
                            try {
                                var json = JSON.parse(text);
                                resolve(successCallback(_this2._meta(res), json));
                            } catch (e) {
                                reject(failCallback(e, res));
                            }
                        }
                    }, function(err) {
                        reject(failCallback(err, res));
                    });
                }
                reject(failCallback(new Error("Server " + url + " responded with " + res.status + ": " + res.statusText), res));
            }, function(err) {
                reject(failCallback(err));
            });
        });
    },
    bindMethod: function bindMethod(actionParams, settings) {
        var _this3 = this;
        if (settings.usejQ) {
            return function() {
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function(xhr, response) {
                    return response;
                };
                var failCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function(error, response) {
                    return {
                        error: error,
                        response: response
                    };
                };
                return _this3.$callFn(settings, conditions, {
                    actionParams: actionParams,
                    callOptions: callOptions
                }, successCallback, failCallback);
            };
        } else {
            return function() {
                var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function(xhr, response) {
                    return response;
                };
                var failCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function(error, response) {
                    return {
                        error: error,
                        response: response
                    };
                };
                return _this3.callFn(settings, conditions, {
                    actionParams: actionParams,
                    callOptions: callOptions
                }, successCallback, failCallback);
            };
        }
    }
};


/***/ })

}]);